import { render, staticRenderFns } from "./RechargeGeoCard.vue?vue&type=template&id=37fd1b95"
import script from "./RechargeGeoCard.vue?vue&type=script&lang=js"
export * from "./RechargeGeoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StoryblokComponent: require('/opt/build/repo/components/Storyblok/Component.vue').default})
